import { dataFetcher } from 'core/services/requestHandler';   

const sendContactUsMessage = async (data = {}, config = {}) => {
  return dataFetcher('submitQuery', data, {method: 'POST', ...config});
};

export { sendContactUsMessage };
